<template>
  <div class="modal-overlay" @click="handleOverlay">
    <transition name="modal">
      <div class="modal-container" @click.stop>
        <!-- Header -->
        <div class="modal-header">
          <ion-icon name="alert-circle-outline" class="modal-icon" />
          <h2 class="modal-title">Eliminar contacto</h2>
          <div class="header-line"></div>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <p v-if="contact" class="confirm-text">
            ¿Seguro que deseas eliminar a
            <strong>{{ displayName }}</strong>
            <span v-if="contact.phone_number"> ({{ contact.phone_number }})</span>?
          </p>
          <p class="warning-msg">
            Esta acción no se puede deshacer y los datos del contacto serán eliminados permanentemente.
          </p>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button class="cancel-btn" :disabled="loading" @click="closeModal">
            Cancelar
          </button>

          <button class="delete-btn" :disabled="loading" @click="confirm">
            <span v-if="loading" class="spinner" aria-hidden="true"></span>
            <span>{{ loading ? 'Eliminando...' : 'Eliminar' }}</span>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "DeleteContactModal",
  props: {
    contact: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayName() {
      if (!this.contact) return '';
      const n = (this.contact.name || '').trim();
      const ln = (this.contact.last_name || '').trim();
      const full = `${n} ${ln}`.trim();
      return full || n || `ID ${this.contact.id}`;
    }
  },
  emits: ["confirm", "cancel", "close"],
  methods: {
    closeModal() {
      this.$emit("cancel");
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm", this.contact);
    },
    handleOverlay(e) {
      if (e.target.classList.contains("modal-overlay")) {
        this.closeModal();
      }
    }
  }
};
</script>

<style scoped>
/* ========== Animación modal ========== */
.modal-enter-active, .modal-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.modal-enter, .modal-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

/* ========== Overlay ========== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: 'Manrope', sans-serif;
}

/* ========== Contenedor ========== */
.modal-container {
  background: #ffffff;
  border-radius: 1rem;
  padding: 1.5rem 1.5rem 1.25rem;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.25);
}

/* ========== Header ========== */
.modal-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.modal-icon {
  font-size: 1.4rem;
  color: #dc2626;
}

.modal-title {
  font-size: 1.1rem;
  font-weight: 800;
  color: #0f172a;
  white-space: nowrap; 
}

.header-line {
  flex: 1;
  height: 1.5px;
  background: #e2e8f0;
  margin-left: 0.75rem;
  border-radius: 999px;
}

/* ========== Cuerpo ========== */
.modal-body {
  margin-top: 1rem;
  font-size: 0.95rem;
  color: #334155;
  line-height: 1.6;
  text-align: left;
}

.modal-body strong { color: #0f172a; }

.warning-msg {
  margin-top: 0.75rem;
  font-weight: 700;
  color: #dc2626;
}

/* ========== Footer ========== */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.4rem;
  gap: 0.75rem;
}

.cancel-btn {
  padding: 0.55rem 1rem;
  background-color: #f8fafc;
  color: #334155;
  border: 1.5px solid #cbd5e1;
  border-radius: 0.65rem;
  font-size: 0.92rem;
  transition: all 0.15s ease;
}
.cancel-btn:hover {
  background-color: #e2e8f0;
  border-color: #94a3b8;
  color: #0f172a;
}
.cancel-btn:disabled {
  opacity: .6;
  cursor: not-allowed;
}

.delete-btn {
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  padding: 0.55rem 1.15rem;
  background-color: #dc2626;
  color: #ffffff;
  border: none;
  border-radius: 0.65rem;
  font-size: 0.92rem;
  transition: background-color .15s ease, transform .1s ease, box-shadow .15s ease;
}
.delete-btn:hover {
  background-color: #b91c1c;
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(220, 38, 38, 0.25);
}
.delete-btn:disabled {
  opacity: .8;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* ========== Spinner ========== */
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff60;
  border-top: 2px solid #ffffff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
